var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco24AudiovisualPlayCircleOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_24_audiovisual_play_circle_outlined",
    "data-name": "ico / 24 / audiovisual / play_circle_outlined",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 36,
    height: 36,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M16,32A16,16,0,1,1,32,16,16.018,16.018,0,0,1,16,32ZM16,3.2A12.8,12.8,0,1,0,28.8,16,12.815,12.815,0,0,0,16,3.2ZM12.4,23.033a1.2,1.2,0,0,1-1.2-1.193V10.161a1.2,1.2,0,0,1,1.84-1.008l9.36,5.823a1.216,1.216,0,0,1,0,2.048l-9.36,5.825A1.2,1.2,0,0,1,12.4,23.033Z",
    transform: "translate(2 2)",
    fill: "#1dbbbe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco24AudiovisualPlayCircleOutlined);
export default __webpack_public_path__ + "static/media/ico - 24 - audiovisual - play_circle_outlined.985ea72314bf303d443cf56adc2a27cf.svg";
export { ForwardRef as ReactComponent };